import React, { memo } from 'react'
import { Heading, Flex, Box, Divider } from 'pcln-design-system'
import { CheckboxCategoryGroup } from '@pcln/filter'
import { Reset } from '../../AllOrNone'
import StopsFilterChips from './StopFilterChips'
import { useIsMobile } from '../../../helpers/useIsMobile'
import { useStopsFilters } from './hooks/useStopsFilters'

/**
 * Stops Filters Component Using Hooks
 * @returns <StopsFilters />
 */
function StopsFilters({ changeHandler, hasUSDestinationsOnly }) {
  const isMobileView = useIsMobile()

  const { stops, stopsHandleChange, resetClick } = useStopsFilters({
    changeHandler,
    isMobileView,
  })

  if (!stops?.length) return null

  return (
    // reason to use pb={'24px'} - design system way of using pb={4} doesnot show correct 24px pb. Instead it shows 32px
    <Box pb={'24px'}>
      <Flex alignItems='center' justifyContent='space-between' mb={2}>
        <Heading fontSize={2} bold>
          Stops
        </Heading>
        <Reset resetHandler={resetClick}>Reset</Reset>
      </Flex>
      <Divider mb={3} mt={0} />
      {!isMobileView ? (
        <StopsFilterChips stops={stops} handleChange={stopsHandleChange} hide2Stops={hasUSDestinationsOnly} />
      ) : (
        <CheckboxCategoryGroup
          filters={stops}
          filterNamePrefix={'stops'}
          handleChange={stopsHandleChange}
          className='flight-stops-filters'
          wrapLabel={true}
          shouldPadConsistently
        />
      )}
    </Box>
  )
}

export default memo(StopsFilters)
